export default __webpack_public_path__ + "static/media/GameStarted.2657a400.png";